import React, { Dispatch, SetStateAction, useEffect, useMemo, useState } from 'react'
import { Container, Row, Col, FormGroup, Label, Button } from "reactstrap"
import HistorialSolicitudes from '../HistorialSolicitudesHE/HistorialSolicitudes'
import { KeyValuePair } from 'components/Types/GeneralTypes'
import { HistorialSolicitudesHorasExtras, InformacionIngresoSolicPagoHE, ResponseHistoriaHE } from '../SolicitudPagoHE/TypesSolicitudPagoHE'
import { ObtenerAniosSolicitudHE, ObtenerHistorialSolicitudesHE, ObtenerInformacionIngresoSolicitudPagoHE, ObtenerMesesSolicitudHE, TieneCargoDirectivo } from '../SolicitudPagoHE/FunctionsSolicitudPagoHE'
import { showAlert, showAlertAviso, showAlertHTML } from 'components/Admin/Horas Extras/Parametros Horas Extras/Actividades/ActividadesHorasExtras'
import Cargando from 'components/Varios/Cargando'
import SelectItem2 from 'components/Varios/SelectNew'
import { MesesPlanificacionHEDTO } from 'components/Admin/Horas Extras/Planificacion Horas Extras/TypesPlanificacionUnidades'
import ModalCargando from 'components/Varios/ModalCargando'
import { GetHojaMarcacion, GetHojaMarcacionNovedad, GuardarHojaMarcaciones } from 'components/UsuarioGeneral/Hoja Marcaciones/ServicesHojaMarcaciones'
import ModalConfirmacion from 'components/Varios/Modals/ModalConfirmacion'
import PDFViewer from 'components/Varios/PDFViewer'
import { ChangeToPromise } from 'functions/GeneralFunctions'
import Swal from 'sweetalert2'
import AnuncioSVG from "../../../../assets/icons/Permisos/Anuncio.svg";
import { useHistory } from 'react-router'
import AlertNew, { TiposAlerta } from 'components/Varios/AlertNew'
import { listadoMeses } from 'functions/DatesFunctions'
import { ParseNombreMes } from 'helpers/DateFunctions'
import { authenticationService } from 'services/authentication.service'

type InformacionModal = {
    urlHojaMarcaciones: string,
    tieneNovedad: boolean
}

export default function InicioHE() {


    const [informacionParaIngresar, setinformacionParaIngresar] = useState<InformacionIngresoSolicPagoHE | undefined>(undefined)
    const [puedesolicitar, setpuedesolicitar] = useState<boolean>(false)
    const [historia, sethistoria] = useState<ResponseHistoriaHE | undefined>(undefined)
    const [loading, setloading] = useState<boolean>(false)
    const [loadingmeses, setloadingmeses] = useState<boolean>(false)
    const [loadingVPmarcaciones, setloadingVPmarcaciones] = useState<boolean>(false)
    const [guardarHojaMarcaciones, setguardarHojaMarcaciones] = useState<boolean>(false)

    //const [urlHojaMarcacion, seturlHojaMarcacion] = useState<string>("")
    const [informacionModalHojaMarcacion, setinformacionModalHojaMarcacion] = useState<InformacionModal | undefined>(undefined)
    const [listadoanios, setlistadoanios] = useState<number[]>([]);
    const [listadomeses, setlistadomeses] = useState<MesesPlanificacionHEDTO[]>([]);

    const [anioSeleccionado, setanioSeleccionado] = useState<number>(-1)
    const [mesSeleccionado, setmesSeleccionado] = useState<number>(-1)

    const history = useHistory();


    async function ObtenerAnios() {
        setloading(true)
        const informacionGeneral = await ObtenerAniosSolicitudHE();
        if (informacionGeneral.status === 200 && informacionGeneral.dataResponse && typeof informacionGeneral.dataResponse !== 'string') {

            const aniosDisponibles: number[] = informacionGeneral.dataResponse;
            const aniosOrdenados: number[] = aniosDisponibles.sort((a, b) => b - a);

            setlistadoanios(aniosOrdenados)
            if (aniosOrdenados.length > 0) {
                setanioSeleccionado(aniosOrdenados[0]);
            }
        } else {
            setlistadoanios([]);
            showAlert("Ha ocurrido un inconveniente", false)
        }
        setloading(false)
    }

    async function ObtenerMeses(anioSeleccionado: number) {
        setloadingmeses(true)
        const informacionGeneral = await ObtenerMesesSolicitudHE(anioSeleccionado);
        if (informacionGeneral.status === 200 && typeof informacionGeneral.dataResponse !== 'string') {

            const mesesDisponibles: MesesPlanificacionHEDTO[] = informacionGeneral.dataResponse;


            setlistadomeses(mesesDisponibles)

            if (mesesDisponibles.length > 1) {
                //const mesesOrdenados = mesesDisponibles.sort((a, b) => a.numeroMes - b.numeroMes);
                //setmesSeleccionado(mesesOrdenados[mesesOrdenados.length - 2].numeroMes)
                setmesSeleccionado(mesesDisponibles[0].numeroMes)
            }
            else if (mesesDisponibles.length === 1) {
                setmesSeleccionado(mesesDisponibles[0].numeroMes)
            }
            else {
                showAlertAviso("Aún no hay meses disponibles del año seleccionado para solicitar horas extras");
            }


        } else {
            setlistadomeses([]);
            showAlert("Ha ocurrido un inconveniente", false);
        }
        setloadingmeses(false)

    }


    async function ObtenerInformacionIngresoSolicitudes(anioSeleccionado: number, mesSeleccionado: number) {
        setloadingmeses(true)
        const data = await ObtenerInformacionIngresoSolicitudPagoHE(anioSeleccionado, mesSeleccionado);
        if (data.status === 200 && data.dataResponse) {
            setinformacionParaIngresar(data.dataResponse)
            if(!data.dataResponse.tieneActvsPlanificadas) {
                const textoplanificado = authenticationService.currentUserValue.genero === "F" ? "planificada": "planificado"

                const contentMensaje =`<div>Ud. no ha sido ${textoplanificado} para laborar horas extras <br/> en el mes de ${ParseNombreMes(mesSeleccionado)}</div>`;

                showAlertHTML(contentMensaje,false )
            }
        }
        else {
            showAlert("Ha ocurrido un inconveniente", false)
        }


        setloadingmeses(false)

    }


    async function PuedeSolicitarHe() {
        setloading(true)

        const respuesta = await TieneCargoDirectivo();

        if (respuesta.status === 200 && respuesta.dataResponse) {

            setpuedesolicitar(respuesta.dataResponse)
        }
        else {
            const mensajeDefault = "Ud. tiene cargo de directivo, por lo que no puede solicitar horas extras.";
            showAlert(respuesta.errorMessage ?? mensajeDefault, false);
            setpuedesolicitar(false)
        }
        setloading(false);

    }

    async function ConsultarHistorialSolicitudHE() {
        setloading(true)

        const respuesta = await ObtenerHistorialSolicitudesHE();

        if (respuesta.status === 200 && respuesta.dataResponse) {
            sethistoria(respuesta.dataResponse);
        }
        else {
            const mensajeDefault = "No ha sido posible consultar información. Comuníquese con Talento Humano";
            showAlert(respuesta.errorMessage ?? mensajeDefault, false);
        }

        setloading(false)
    }

    async function ObtenerVistaPreviaHojaMarcaciones(anio: number, mes: number, informacionParaIngresar: InformacionIngresoSolicPagoHE | undefined) {
        if (informacionParaIngresar && informacionParaIngresar.hojaMarcacionGenerada && !informacionParaIngresar.puedeIngresarSolicitud) {
            showAlertAviso("Ud. ya tiene una solicitud ingresada.");
            return;
        }





        setloadingVPmarcaciones(true)


        const fechadesde = new Date(anio, mes - 1, 1, 0, 0, 0, 0);
       
        var fechahasta = new Date(anio, mes, 0, 0, 0, 0, 0);

        if (mes == 12 && informacionParaIngresar) {
            fechahasta = new Date(anio, mes - 1, informacionParaIngresar.maximoDiaMes, 0, 0, 0, 0);
        }


        const respuesta = await GetHojaMarcacionNovedad(fechadesde, fechahasta)

        if (respuesta.status === 200 && respuesta.dataResponse) {

            if (respuesta.dataResponse.referenciaHojaGuardada !== "") {

                const texto = "<div> La hoja de marcaciones para este año y mes ya ha sido generada  </div>";
                const result = await Swal.fire({
                    html: texto,
                    imageUrl: AnuncioSVG,
                    showCancelButton: true,
                    cancelButtonText: 'Cancelar',
                    confirmButtonText: 'Ingresar solicitud de Horas Extras',
                    reverseButtons: true,
                    customClass: {
                        cancelButton: 'btn-cancelar',
                        confirmButton: 'btn-aceptar',
                        popup: 'custom-popup',
                        image: 'custom-image-swal'
                    },
                });


                if (result.isConfirmed) {
                    history.push({
                        pathname: '/web/solicitud_pago_horas_extras/',
                        state: { anio, mes }
                    });

                    //await OnClickAccionSolicitudReverso(1, informacionUnidad);
                } else if (result.isDismissed && result.dismiss === Swal.DismissReason.cancel) {
                    //await OnClickAccionSolicitudReverso(2, informacionUnidad);
                } else {
                    //setloadingAccion(false);

                    return;
                }
            }
            else {
                setinformacionModalHojaMarcacion({
                    tieneNovedad: respuesta.dataResponse.tienenovedad,
                    urlHojaMarcaciones: respuesta.dataResponse.hojamarcacion
                })
            }


        }
        else {
            showAlert("No ha sido posible generar su hoja de marcaciones", false);
        }

        setloadingVPmarcaciones(false)
    }

    async function GenerarHojaMarcacionesDelMes(anio: number, mes: number) {
        setguardarHojaMarcaciones(true)
        const fechadesde = new Date(anio, mes - 1, 1, 0, 0, 0, 0);
        const fechahasta = new Date(anio, mes, 0, 0, 0, 0, 0);



        const respuesta = await GuardarHojaMarcaciones(fechadesde, fechahasta)

        if ((respuesta.status === 200 || respuesta.status === 204)) {


            const texto = "<div> Su hoja de marcaciones ha sido generada con éxito  </div>";
            const result = await Swal.fire({
                html: texto,
                imageUrl: AnuncioSVG,
                showCancelButton: true,
                cancelButtonText: 'Cancelar',
                confirmButtonText: 'Ingresar solicitud de Horas Extras',
                reverseButtons: true,
                customClass: {
                    cancelButton: 'btn-cancelar',
                    confirmButton: 'btn-aceptar',
                    popup: 'custom-popup',
                    image: 'custom-image-swal'
                },
            });


            if (result.isConfirmed) {
                history.push({
                    pathname: '/web/solicitud_pago_horas_extras/',
                    state: { anio, mes }
                });
            } else if (result.isDismissed && result.dismiss === Swal.DismissReason.cancel) {
            } else {
                ;
            }




            setguardarHojaMarcaciones(false)
            return 1;
        }
        else {
            showAlert("No ha sido posible generar su hoja de marcaciones", false);
            setguardarHojaMarcaciones(false)
            return -1;
        }

    }

    function GetTextoHorasPlanificacdas(informacion: InformacionIngresoSolicPagoHE | undefined, textoMes:string|undefined,anio:string) {
        if (informacion) {
            var textoSuplementarias = ""
            var textoExtraordinarias = ""
            const tieneHorasSuplementarias: boolean = informacion.horasSuplementarias > 0;
            const tieneHorasExtraordinarias: boolean = informacion.horasExtraordinarias > 0;

            if (tieneHorasSuplementarias) {
                textoSuplementarias = `${informacion.horasSuplementarias} horas suplementarias`
            }

            if (tieneHorasExtraordinarias) {
                if (tieneHorasSuplementarias) {
                    textoSuplementarias += " y "
                }
                textoExtraordinarias = `${informacion.horasExtraordinarias} horas extraordinarias`
            }

            if(!tieneHorasSuplementarias && !tieneHorasExtraordinarias){
                return "Ud. no tiene horas planificadas para ese año y mes";
            }

            return `Ud. tiene planificadas ${textoSuplementarias} ${textoExtraordinarias} para ${textoMes??""} del año ${anio}`
        }
        return ""
    }


    const contenidoModalHojaMarcacion = useMemo(() => {





        if (informacionModalHojaMarcacion) {

            if (informacionModalHojaMarcacion.tieneNovedad) {



                //showAlert("Su hoja de marcaciones presenta novedades. Por favor, justifique las jornadas correspondientes o comuníquese con la Dirección de Talento Humano.", false);
            }


            return (
                <div className={"containerPdfCertificadoHojaMarcacionVP"} >

                    <object data={informacionModalHojaMarcacion.urlHojaMarcaciones + "#zoom=110"}
                        type="application/pdf"
                        className='container-pdf mb-1'
                    />
                    {
                        informacionModalHojaMarcacion.tieneNovedad &&
                        <AlertNew
                            mensaje='Su hoja de marcaciones presenta novedades. Por favor, justifique las jornadas correspondientes o comuníquese con la Dirección de Talento Humano.'
                            oncloseElement={() => console.log()}
                            tipo={TiposAlerta.ADVERTENCIA}
                        />


                    }



                </div>
            )
        } else {
            return <></>
        }


    }, [informacionModalHojaMarcacion])

    const handleChangeSelect = (setter: Dispatch<SetStateAction<number>>, name: string) => (value: string | number) => {
        setter(Number(value));
        setmesSeleccionado(-1)
    };

    useEffect(() => {
        window.location.href = "https://th.espol.edu.ec/user/informacion-laboral/pagos";
        //PuedeSolicitarHe()
    }, [])

    useEffect(() => {
        if (puedesolicitar) {
            ObtenerAnios()
            ConsultarHistorialSolicitudHE();
        }
    }, [puedesolicitar])


    useEffect(() => {
        if (anioSeleccionado > 0) {
            ObtenerMeses(anioSeleccionado)
        }

    }, [anioSeleccionado])

    useEffect(() => {
        if (anioSeleccionado > 0 && mesSeleccionado > 0) {
            ObtenerInformacionIngresoSolicitudes(anioSeleccionado, mesSeleccionado)
        }

    }, [anioSeleccionado, mesSeleccionado])

    return (
        <div className="content">
            <h4> SOLICITUD PARA REPORTAR LAS HORAS EXTRAS LABORADAS DEL MES</h4>
            {
                loading &&
                <Cargando />
            }
            {
                <Container fluid={true}>
                    <Row>
                        <Col xl={2}>
                            <FormGroup>
                                <Label for="anio">Año*</Label>
                                <SelectItem2
                                    options={listadoanios.map(anio => ({ value: anio, label: anio }))}
                                    placeholder=""
                                    name="anio"
                                    id="anio"
                                    icon="fa-caret-down"
                                    value={anioSeleccionado}
                                    onChange={(e) => {
                                        //handleChangeSelect(setanioSeleccionado, "anio")
                                        setanioSeleccionado(e)
                                        setmesSeleccionado(-1)
                                    } }
                                />
                            </FormGroup>
                        </Col>
                        <Col xl={2}>
                            <FormGroup>
                                <Label for="mes">Mes*</Label>
                                <SelectItem2
                                    options={listadomeses.map(mes => ({ value: mes.numeroMes, label: mes.nombreMes }))}
                                    placeholder=""
                                    name="mes"
                                    id="mes"
                                    icon="fa-caret-down"
                                    value={mesSeleccionado}
                                    
                                    onChange={(e) => {
                                        setmesSeleccionado(e)
                                    }}
                                />
                            </FormGroup>
                        </Col>
                        <Col xl={2} style={{ display: "flex" }}>
                            <Button
                                onClick={() => ObtenerVistaPreviaHojaMarcaciones(anioSeleccionado, mesSeleccionado, informacionParaIngresar)}
                                disabled={anioSeleccionado < 0 || mesSeleccionado < 0 || informacionParaIngresar === undefined || (informacionParaIngresar !== undefined && ((informacionParaIngresar.puedeIngresarSolicitud === false && informacionParaIngresar.hojaMarcacionGenerada === true)) || !informacionParaIngresar.tieneActvsPlanificadas)}
                            >
                                {informacionParaIngresar?.hojaMarcacionGenerada === false ? "GENERAR PDF DE REGISTRO E/S" : "INGRESAR NUEVA SOLICITUD DE PAGO DE HE"}
                            </Button>
                        </Col>
                    </Row>
                    {
                        informacionParaIngresar !== undefined &&
                        <Row>
                            <Col xl={12}>
                                <p className='small-error'>
                                    {GetTextoHorasPlanificacdas(informacionParaIngresar,listadoMeses.find((v) => v.valorMes === informacionParaIngresar.mesUltimaPlanificacion)?.mes,anioSeleccionado.toString())}
                                </p>
                            </Col>
                        </Row>
                    }

                </Container>

            }
            {
                historia && !loading &&
                <HistorialSolicitudes
                    historia={historia}

                />
            }
            {

                <ModalCargando
                    show={loadingmeses}
                    onClose={() => setloadingmeses(false)}
                    size='md'
                />
            }

            <ModalCargando
                show={loadingVPmarcaciones}
                onClose={() => setloadingVPmarcaciones(false)}
                size='md'
            />
            <ModalConfirmacion
                show={informacionModalHojaMarcacion !== undefined && informacionModalHojaMarcacion.urlHojaMarcaciones !== ""}
                onClose={() => setinformacionModalHojaMarcacion(undefined)}
                size='xl'
                asyncAccion={true}
                asyncClose={false}
                hideBotonCerrar={true}
                closeAfterAccion={true}
                nombreBotonAccion='GENERAR PDF Y CONTINUAR'
                //classNameBotonAccion='bg-espol-color-blue'
                colorButtonAccion='secondary'
                contentModal={contenidoModalHojaMarcacion}
                mensajeConfirmacion=''
                asyncOnClick={() => GenerarHojaMarcacionesDelMes(anioSeleccionado, mesSeleccionado)}
                classNameContentModal='modalBodyVPEmisionCert'
                classNameAllModal='custom-modal-style'
                showTituloModal={false}
                disabledBotonAccion={informacionModalHojaMarcacion !== undefined && informacionModalHojaMarcacion.tieneNovedad}

            />

        </div>

    )
}
